import {Injectable} from "@angular/core";
import {ApiGouvResult} from "../model/api-gouv-adress.model";

@Injectable({
  providedIn: 'platform'
})
export class ApiGouvAdresseService {

  constructor() {
  }

  getAdresse(text: string): Promise<ApiGouvResult> {
    return new Promise((resolve, reject) => {
      fetch(`https://api-adresse.data.gouv.fr/search/?q=${text}&limit=10`)
        .then(response => response.json())
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(new Error(error));
        });
    });
  }
}
